<script>
export default {
  name: 'WorkOrderDetailTabs',
  props: {
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      tabs: [
        { value: 'customer-site', label: 'Customer & site' },
        { value: 'what-to-install', label: 'What to install' },
        { value: 'packages', label: 'Packages' },
        { value: 'schedule-crew', label: 'Schedule & crew', badge: 3 },
      ],
    }
  },
}
</script>

<template>
  <nav class="wo-detail-tabs" aria-label="Work order detail tabs">
    <button
      v-for="tab in tabs"
      :key="tab.value"
      type="button"
      class="wo-detail-tab"
      :class="{ 'wo-detail-tab--active': value === tab.value }"
      @click="$emit('input', tab.value)"
    >
      {{ tab.label }}
      <span v-if="tab.badge" class="wo-tab-badge">{{ tab.badge }}</span>
    </button>
  </nav>
</template>
